var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feed-media"},_vm._l((_vm.imageList),function(img,index){return _c('FeedImage',{key:index,attrs:{"imgUrl":img,"urlList":_vm.feed.uriKey}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }